<template>
    <div>
       <div class="dropdown-button place-right">
            <a  class="button dropdown-toggle bg-backup fg-black pl-5" >
                <div class="text-left">
                 {{ $t('Backup') }}  
                </div>
                
            </a>
            <ul class="d-menu border place-right mt-2" data-role="dropdown">
                <li>
                    <router-link to="/backup" class="text-bold" :disabled="!$root.connectionsStates[pc.id]">
                      <span class="mif-add icon text-bold"></span>{{ $t("New Backup").toUpperCase() }}
                    </router-link>
                </li>
               
                                
                <template v-if="$ONEServiceTypeInfo!=null" v-for="t in restoreTypes"  :disabled="!$root.connectionsStates[pc.id]" >

                    <template v-for="microsoft_t in $root.getMicrosoftTypes()">

                        <li  v-if="t == $ONEServiceType.Microsoft" :key="microsoft_t" >
                            <a @click="$root.$emit('OPENRESTOREDIALOG', microsoft_t, null)">RESTORE <b>{{ $ONEServiceTypeInfo[microsoft_t].name }}</b></a>
                        </li>
                   
                        <li v-else>
                            <a @click="$root.$emit('OPENRESTOREDIALOG', t, null)">RESTORE <b>{{ $ONEServiceTypeInfo[t].name }}</b></a>
                        </li>
                    </template>
                
                    
                </template>
             
            </ul> 
        </div>
    </div>
</template>
<script>
export default {
    name: "PCBackupLink",
    data() {
        return {
            restoreTypes: [this.$ONEServiceType.Microsoft, this.$ONEServiceType.HyperV, this.$ONEServiceType.ESXi, this.$ONEServiceType.FileFolder, this.$ONEServiceType.Network],
        }
    },
    props: {
        pc: {
            type: Object,
            required: true
        }
    }
}
</script>